<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
    <div class="container-fluid">
      <div class="row" v-if="isActive">
        <div class="col-12 align-self-center text-center">
          <div class="login-wrap">
            <div class="logo">
              <svg
                width="10rem"
                viewBox="0 0 1273 258"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              >
                <g transform="matrix(1,0,0,1,-180.328,-1624.95)">
                  <g transform="matrix(1,0,0,1,-243.308,-514.209)">
                    <g transform="matrix(0.907689,0,0,0.907689,58.4462,665.887)">
                      <text
                        x="750.529px"
                        y="1842.46px"
                        style="font-family:'Poppins-Bold', 'Poppins';font-weight:700;font-size:194.657px;fill:rgb(0,20,56);"
                      >Demobottle</text>
                    </g>
                  </g>
                  <g transform="matrix(1,0,0,1,-243.308,-514.209)">
                    <g transform="matrix(0.502082,0,0,0.502082,228.356,1225.3)">
                      <circle cx="645.362" cy="2076.57" r="256.422" style="fill:rgb(218,242,255);" />
                      <clipPath id="_clip1">
                        <circle cx="645.362" cy="2076.57" r="256.422" />
                      </clipPath>
                      <g clip-path="url(#_clip1)">
                        <g transform="matrix(0.795202,0,0,0.897731,210.49,307.692)">
                          <path
                            d="M127.341,1896.76C320.635,1975.57 543.371,1774.65 607.022,1840.67C645.477,1880.55 560.849,1956.8 607.022,2036.27C671.917,2147.96 878.354,2007.58 932.621,2061.57C986.887,2115.56 1020.49,2313.42 932.621,2360.21C814.003,2423.38 355.13,2517.83 220.916,2440.59C86.703,2363.35 -167.643,1776.49 127.341,1896.76Z"
                            style="fill:rgb(37,223,255);"
                          />
                        </g>
                        <g transform="matrix(1.25332,0,0,1.17862,-83.0768,-140.548)">
                          <path
                            d="M305.954,1867.98C498.225,1843.13 518.657,1988.64 602.572,2003.1C672.365,2015.11 751.56,1957.66 809.443,1954.68C962.845,1946.79 916.821,2009.55 932.621,2061.57C953.15,2129.15 1020.49,2313.42 932.621,2360.21C814.003,2423.38 325.361,2522.63 220.916,2440.59C116.472,2358.55 -15.378,1909.5 305.954,1867.98Z"
                            style="fill:url(#_Linear2);"
                          />
                        </g>
                        <g transform="matrix(1.25332,0,0,1.17862,-83.0768,-140.548)">
                          <path
                            d="M305.954,1867.98C498.225,1843.13 518.657,1988.64 602.572,2003.1C672.365,2015.11 751.56,1957.66 809.443,1954.68C962.845,1946.79 916.821,2009.55 932.621,2061.57C953.15,2129.15 1020.49,2313.42 932.621,2360.21C814.003,2423.38 325.361,2522.63 220.916,2440.59C116.472,2358.55 -15.378,1909.5 305.954,1867.98Z"
                            style="fill:url(#_Linear3);"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <defs>
                  <linearGradient
                    id="_Linear2"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(829.582,0,0,648.147,147.065,2150.59)"
                  >
                    <stop offset="0" style="stop-color:rgb(69,67,255);stop-opacity:1" />
                    <stop offset="1" style="stop-color:rgb(0,242,254);stop-opacity:1" />
                  </linearGradient>
                  <linearGradient
                    id="_Linear3"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(829.582,0,0,648.147,147.065,2150.59)"
                  >
                    <stop offset="0" style="stop-color:rgb(69,67,255);stop-opacity:1" />
                    <stop offset="1" style="stop-color:rgb(0,242,254);stop-opacity:1" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div v-bind:class="[isActive === true ? 'registerAnimation': 'registerAnimation']">
              <span class="title login--title">Register Here</span>
              <span class="title-under">Welcome to Demobottle.</span>
              <form class="login--form">
                <div class="inputStyle">
                  <input
                    class="email login--input-bottom"
                    type="text"
                    v-model="name"
                    placeholder="Your Name"
                    name="name"
                  />
                </div>
                <br />
                <div class="inputStyle">
                  <input
                    class="email login--input-bottom"
                    type="email"
                    v-model="email"
                    placeholder="Email adres"
                    name="email"
                  />
                </div>
                <div class="inputStyle">
                  <input
                    class="password login--input-bottom"
                    type="password"
                    v-model="password"
                    placeholder="Password"
                    name="password"
                  />
                </div>
                <div class="inputStyle">
                  <input
                    class="password login--input-bottom"
                    type="password"
                    v-model="repeatPassword"
                    placeholder="Repeat Password"
                    name="Repeat Password"
                  />
                </div>
              </form>
              <br />
              <span class="form--error" v-for="error in errors" :key="error">
                {{error}}
                <br />
              </span>

              <button
                class="btn btn-dark login--button-second"
                v-on:click="$emit('switchActive')"
              >Back to Login</button>
              <button class="btn btn-primary login--button-main" @click="register">Register</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "register",
  props: { isActive: Boolean },
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      errors: null,
      name: null,
      email: null,
      password: null,
      repeatPassword: null,
    };
  },
  methods: {
    register() {
      var self = this;
      this.isLoading = true;
      if (!this.password === this.repeatPassword) {
        self.errors = "Passwords do not match";
        self.isLoading = false;
      } else {
        axios
          .post("api/user/register", {
            name: self.name,
            email: self.email,
            password: self.password,
          })
          .then(function (response) {
            self.isLoading = false;
            localStorage.token = response.data.token.access_token;

            self.$router.push("/");
          })
          .catch(function (error) {
            self.errors = error.response.data;
            self.isLoading = false;
          });
      }
    },
  },
};
</script>
